import { render, staticRenderFns } from "./ttshop_invoiceInformation.vue?vue&type=template&id=048a4bfc&scoped=true&"
import script from "./ttshop_invoiceInformation.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoiceInformation.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoiceInformation.vue?vue&type=style&index=0&id=048a4bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a4bfc",
  null
  
)

export default component.exports